module.exports = __webpack_public_path__ + "static/media/logo_b.7b8b9c4e.png";